import Collection from './generic/collection'
import { parseJSON } from './utils/parseJSON'
import { clearBtn } from './catalogFilter'

export const instance = '[data-js-toggle-view]'

export default class ToggleView {
  els = {
    instance: instance,
    toggleBtn: '[data-js-toggle-view-btn]',
    toggleBody: '[data-js-toggle-view-body]',
    toggleTarget: '[data-js-toggle-view-target]',
    filterWrapper: '.catalog__filter--type'
  }

  stateClasses = {
    filterDisable: 'catalog__filter--disable',
  }

  stateDataAttr = {
    toggleBtnDisabled: 'disabled',
    toggleTargetHidden: 'hidden'
  }

  constructor (instance) {
    this.instance = instance
    this.cfg = parseJSON(this.instance.dataset.jsToggleView)
    this.dependentNodes = []
    this.toggleBody = document.querySelector(`[data-js-toggle-view-body=${this.cfg.for}]`)
    this.activeToggleBtn = this.instance.querySelector(`${this.els.toggleBtn}:is([disabled])`)
    this.targetToggleList = this.toggleBody.querySelectorAll(this.els.toggleTarget)

    this.init()
    this.bindEvents()
  }

  getDependentNodes () {
    this.cfg.dependencies.forEach(item => {
      const dependTarget = document.querySelector(`[data-js-filter-id=${item.selector}]`)
      dependTarget
        ? this.dependentNodes.push({
          node: dependTarget,
          dependenceFrom: item.dependenceFrom
        })
        : false
    })
  }

  setDependentNodes() {
    const currentState = this.activeToggleBtn.dataset.jsToggleViewBtn
    this.dependentNodes.forEach(item => {
      item.dependenceFrom === currentState
        ? item.node.closest(this.els.filterWrapper).classList.add(this.stateClasses.filterDisable)
        : item.node.closest(this.els.filterWrapper).classList.remove(this.stateClasses.filterDisable)
    })
  }

  clearFilters(container) {
    container.querySelectorAll(clearBtn).forEach(btn => btn.click())
    this.activeToggleBtn.closest(this.els.instance).querySelectorAll(clearBtn).forEach(btn => btn.click())
  }

  toggle ({ target }) {
    if (this.checkTarget(target)) {
      if (!this.checkActiveToggle(target)) {
        this.activeToggleBtn.removeAttribute(this.stateDataAttr.toggleBtnDisabled)
        this.activeToggleBtn = target
        this.activeToggleBtn.setAttribute(this.stateDataAttr.toggleBtnDisabled, '')

        this.targetToggleList.forEach(node => {
          if (node.attributes.hasOwnProperty(this.stateDataAttr.toggleTargetHidden)) {
            node.removeAttribute(this.stateDataAttr.toggleTargetHidden)
          } else {
            node.setAttribute(this.stateDataAttr.toggleTargetHidden, '')
            this.clearFilters(node)
          }
        })

        this.setDependentNodes()
      }
    }
  }

  checkActiveToggle (node) {
    return node === this.activeToggleBtn
  }

  checkTarget (node) {
    return node.dataset.hasOwnProperty('jsToggleViewBtn')
  }

  init () {
    this.getDependentNodes()
  }

  bindEvents () {
    this.instance.addEventListener('click', (e) => this.toggle(e))
  }
}

export class ToggleViewCollection extends Collection {
  constructor () {
    super(instance, ToggleView)
    this.init()
  }

  init () {
    document.querySelectorAll(instance).forEach(el => {
      this.collection = new ToggleView(el)
    })
  }

}